import React from 'react';

const Spinner = () => (
  <span className="inline-block w-4 h-4 border-2 border-white/60 border-t-transparent rounded-full animate-spin" />
);

const HomebaseActionPanel = ({
  planningState,
  onGenerate,
  ctaLabel = 'Generate Day 1 Itinerary',
  itineraryReady = true,
  onUnavailable,
}) => {
  const ready = planningState?.ready;
  const loading = planningState?.loading;
  const error = planningState?.error;
  const retry = planningState?.retry;

  const isProcessing = !ready && !error;

  let buttonLabel = ctaLabel;
  if (!itineraryReady) {
    buttonLabel = 'Itinerary Planner Coming Soon';
  } else if (error) {
    buttonLabel = 'Retry Trip Setup';
  } else if (isProcessing) {
    buttonLabel = loading ? 'Finishing trip setup…' : 'Preparing trip details…';
  }

  const handleClick = () => {
    if (!itineraryReady) {
      onUnavailable?.();
      return;
    }
    if (error) {
      const maybePromise = retry?.();
      if (maybePromise?.catch) {
        maybePromise.catch(() => {
          /* handled via planningError state */
        });
      }
      return;
    }
    if (ready) {
      onGenerate?.();
    }
  };

  const buttonDisabled = itineraryReady ? (error ? false : !ready) : false;

  return (
    <div className="flex flex-col">
      <button
        onClick={handleClick}
        disabled={buttonDisabled}
        className={`btn-primary-cta w-full px-8 py-4 text-lg flex items-center justify-center gap-2 ${buttonDisabled && !error ? 'opacity-70 cursor-not-allowed' : ''}`}
      >
        {loading && isProcessing && <Spinner />}
        <span>{buttonLabel}</span>
      </button>
    </div>
  );
};

export default HomebaseActionPanel;
